import { useWoody } from '../../woody/woody.js';
import { useQuery } from '@tanstack/react-query';
import { authQueryKeys } from './authQueryKeys.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryOauthClient = (clientId, queryOptions) => {
  const { client } = useWoody();
  return useQuery({
    queryKey: authQueryKeys.oauthClient(clientId),
    queryFn: async (params) => {
      const safeClientId = params.queryKey[1];
      return client.v2({
        endpoint: "/v2/oauth/client/{clientId}",
        params: {
          clientId: safeClientId
        }
      });
    },
    ...queryOptions,
    enabled: isQueryEnabled([
      queryOptions?.enabled,
      !!clientId
    ])
  });
};

export { useQueryOauthClient };
//# sourceMappingURL=useQueryOauthClient.js.map
